import { CONSOLE_RESPONSE_ENABLE } from '../../../config/app';

export const responseSuccessFnForTranspanrent = (response) => response;

export const responseSuccessFn = (responseObj) => {
  // 自定义响应成功逻辑，全局拦截接口，根据不同业务做不同处理，响应成功监控等
  // 打印响应参数
  if (CONSOLE_RESPONSE_ENABLE) {
    // eslint-disable-next-line no-console
    console.info('responsetInterceptorFn', `url: ${responseObj.config.url}`, responseObj);
  }
  return responseObj;
};

export const responseFailFn = (error) => {
  if (CONSOLE_RESPONSE_ENABLE) {
    // eslint-disable-next-line no-console
    console.log('responseFailFn', error);
  }
  // 响应失败，可根据 error.message 和 error.response.status 来做监控处理
  // ...
  // message.error(error.message);

  return Promise.reject(error);
};
